import type { Places } from '~/types/places';

const PLACES_PROFILE: Places = {
  business: {
    bank: -10,
    government: -5,
    office: -15,
  },
  education: {
    childcare: -10,
    high_school: -5,
    library: -5,
    primary: -5,
    university: -5,
  },
  essentials: {
    electricity: 5,
    gas: 5,
    sewers: 5,
    waste: 5,
    water: 10,
  },
  food: {
    bakery: 5,
    coffee: 7,
    fast_food: 12,
    restaurant: 15,
  },
  health: {
    clinic: 5,
    dentist: -5,
    hospital: -5,
    pharmacy: 5,
  },
  nature: {
    beach: 12,
    forest: 10,
    lake: 10,
    mountain: 7,
    park: 15,
    river: 10,
  },
  religion: {
    church: 0,
    mosque: 0,
  },
  shops: {
    grocery: 8,
    mall: 15,
  },
  soil: {
    clay: -5,
    loam: 0,
    peat: -10,
    salt: -15,
    sand: 10,
    silt: 0,
  },
  sport: {
    gym: 5,
    pool: 5,
  },
  telecom: {
    cable_tv: 5,
    fiber_optic: 10,
    network_4g: 10,
    network_5g: 7,
    phone: 12,
  },
  transport: {
    airport: 5,
    bus: 10,
    ferry: 0,
    gas_station: 5,
    metro: 10,
    parking: 12,
    taxi: 15,
    train: 10,
    tram: 10,
  },
};

export default PLACES_PROFILE;
